<template>
<div id="app">
  <div class="wrapper">
    <publicNav></publicNav>
    <router-view class="wrapper"></router-view>
  </div>
  <publicFooter></publicFooter>
</div>
</template>

<script>
import  publicNav from '@/components/public/nav.vue'
import  publicFooter from '@/components/public/footer.vue'
export default {
  name: 'App',
  components: {
    publicNav,
    publicFooter
  }
}
</script>

<style>
html,body{font-family:Arial,"Poppins",sans-serif;margin:0;padding:0;}
ul{margin:0;padding:0;list-style:none;outline:none;}
.wrapper a{display:inline-block;margin:0;padding:0;text-decoration:none;outline:none;}
.wrapper a:link,.wrapper a:visited,.wrapper a:hover,.wrapper a:active{text-decoration:none;outline:none;}
.wrapper p,.wrapper dl,.wrapper dd{margin:0;}
.pull-left{float:left!important;}
.pull-right{float:right!important;}
.text-right{text-align:right;}
.no-more{display:block;padding:15px 0;font-size:16px;color:#333;text-align:center;background-color:#fff;}
.alert-mes{position:fixed;top:50%;left:50%;z-index:2000;padding:15px;min-width:180px;max-width:240px;font-size:15px;color:#fff;text-align:center;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background:rgba(0,0,0,0.7);border-radius:5px;}
.el-upload .el-upload__input,.el-upload input[type=file]{display:none;}
.wrapper{overflow:hidden;width:100%;max-width:1800px;margin:0 auto;}
.empty-img{display: block;width:100%;}
.clear{clear:both;}
</style>
